import { Component, OnInit, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { format, parseISO } from 'date-fns';
import { ptBR, enUS, es, it, fr, ja } from 'date-fns/locale';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { UserProvider } from 'src/app/services/user/user';

@Component({
  selector: 'app-list-imagem-resumo',
  templateUrl: './list-imagem-resumo.component.html',
  styleUrls: ['list-imagem-resumo.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ImagePipe
  ]
})
export class ListImagemResumoComponent implements OnInit {
  @Input()
  config: any;
  locale: Locale;
  LOCALES: Record<string, Locale> = {
    pt: ptBR,
    en: enUS,
    es: es,
    it: it,
    fr: fr,
    ja: ja,
  };

  constructor(
    public modalCtrl: ModalController,
    private userProvider: UserProvider,
  ) {
    const currentLang = this.userProvider.linguagem || "ptBr";
    this.locale = this.LOCALES[currentLang] || ptBR;
   }

  ngOnInit() { }

  getMes() {
    return format(parseISO(this.config.date), 'MMM', { locale: this.locale});
  }

  getDia() {
    return format(parseISO(this.config.date), 'dd', { locale: this.locale});
  }

  async abrirNoticia() {
    const modalPage = await this.modalCtrl.create({ 
      component: NoticiaDetalhesPage,
      componentProps: { 'id': this.config.id }
    });
    modalPage.present();
  }

}
